module.exports = __webpack_public_path__ + "img/1 (51).d66f6a65.png";